/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import * as Examples from './Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a",
    ul: "ul",
    li: "li",
    strong: "strong",
    code: "code",
    em: "em",
    h3: "h3",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsxs(_components.p, {
      children: ["To make it easier to build application layout and ", _jsx(_components.a, {
        href: "/uilib/extensions/forms",
        children: "form"
      }), "-views in line with defined design sketches, there are a number of components for layout."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/spacing",
              children: "Spacing"
            })
          }), " table and information."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/media-queries",
              children: "Media Queries"
            })
          }), " and breakpoints table and information."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/flex",
              children: "Flex"
            })
          }), " is a building block for CSS flexbox based layout of contents, components and ", _jsx(_components.a, {
            href: "/uilib/extensions/forms",
            children: "forms"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/grid",
              children: "Grid"
            })
          }), " is a layout system for CSS grid based layout of contents."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/space",
              children: "Space"
            })
          }), " is a component that provides ", _jsx(_components.code, {
            children: "margins"
          }), " within the ", _jsx(_components.a, {
            href: "/uilib/usage/layout/spacing#spacing-helpers",
            children: "provided spacing patterns"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Deprecated layout components"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/form-set",
              children: "FormSet"
            })
          }), " is deprecated. Use ", _jsx(_components.a, {
            href: "/uilib/layout/flex",
            children: "Flex"
          }), ", the ", _jsx(_components.a, {
            href: "/uilib/extensions/forms",
            children: "Forms"
          }), " extension and the Eufemia ", _jsx(_components.a, {
            href: "/uilib/usage/customisation/provider-info",
            children: "Provider"
          }), " as an replacement."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/form-row",
              children: "FormRow"
            })
          }), " is deprecated. Use ", _jsx(_components.a, {
            href: "/uilib/layout/flex",
            children: "Flex"
          }), " and the ", _jsx(_components.a, {
            href: "/uilib/extensions/forms",
            children: "Forms"
          }), " extension as an replacement."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Units and responsiveness"
    }), "\n", _jsxs(_components.p, {
      children: ["Please – use ", _jsx(_components.code, {
        children: "rem"
      }), " instead of ", _jsx(_components.code, {
        children: "px"
      }), " for all of your custom CSS, and make sure;"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["you always use the nearest half ", _jsx(_components.code, {
          children: "rem"
        }), " value, like ", _jsx(_components.em, {
          children: "0.5rem"
        }), ", ", _jsx(_components.em, {
          children: "1rem"
        }), " or ", _jsx(_components.em, {
          children: "1.5rem"
        }), " and so forth."]
      }), "\n", _jsxs(_components.li, {
        children: ["you always get a ", _jsx(_components.strong, {
          children: "total computed height"
        }), " within the grid."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["This results in maintaining the integrity of the ", _jsx(_components.strong, {
        children: "8px"
      }), " base grid."]
    }), "\n", _jsx(_components.h3, {
      children: "Exceptions"
    }), "\n", _jsxs(_components.p, {
      children: ["There are exceptions for when you define a \"minimum\" of an area, such as ", _jsx(_components.code, {
        children: "min-width"
      }), ". Because it will increase in size when a larger browser font-size is used. In that case, user ", _jsx(_components.code, {
        children: "px"
      }), " as your sizing unit."]
    }), "\n", _jsx(_components.h3, {
      children: "Smaller Units"
    }), "\n", _jsxs(_components.p, {
      children: ["Sometimes you may need a compensation of only a few pixels. Heres how to calculate the correct ", _jsx(_components.em, {
        children: "rem"
      }), " values:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["1px = ", _jsx(_components.code, {
          children: "1/16x1"
        }), " = ", _jsx(_components.strong, {
          children: "0.0625rem"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["2px = ", _jsx(_components.code, {
          children: "1/16x2"
        }), " = ", _jsx(_components.strong, {
          children: "0.125rem"
        })]
      }), "\n", _jsx(_components.li, {
        children: "And so on ..."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Columns"
    }), "\n", _jsx(_components.p, {
      children: "UX designers are using a 12 column system, along with a 4 and 6 column system, during their design processes."
    }), "\n", _jsx(_components.h3, {
      children: "What are the differences between Flex and Grid?"
    }), "\n", _jsx(_components.p, {
      children: "Both to support different sizing of items on different media breakpoints."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Flex"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Uses CSS ", _jsx(_components.code, {
        children: "flexbox"
      }), "."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Best suited for Forms layout."
      }), "\n", _jsx(_components.li, {
        children: "Can either stack vertically or horizontally."
      }), "\n", _jsx(_components.li, {
        children: "Can be used with any kind of children."
      }), "\n", _jsx(_components.li, {
        children: "Even distribution of space."
      }), "\n", _jsx(_components.li, {
        children: "Keeps order of items like they were given in the DOM structure."
      }), "\n", _jsx(_components.li, {
        children: "Items can be sized in percentage."
      }), "\n", _jsx(_components.li, {
        children: "When a size (percentage) is given, they stack horizontally."
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import { Flex } from '@dnb/eufemia'\nrender(\n  <Flex.Container>\n    <Flex.Item>content</Flex.Item>\n    <OtherComponent>content</OtherComponent>\n  </Flex.Container>,\n)\n"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Grid"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Uses CSS ", _jsx(_components.code, {
        children: "grid"
      }), "."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Best suited for applications with a column based layout."
      }), "\n", _jsx(_components.li, {
        children: "Columns do change between 4, 6 and 12 on the given size (media query) of the browser or screen size."
      }), "\n", _jsx(_components.li, {
        children: "The Grid.Container depends on Grid.Item."
      }), "\n", _jsx(_components.li, {
        children: "Items do span from column \"a\" to \"b\"."
      }), "\n", _jsx(_components.li, {
        children: "Items can have different order in opposition from what's given in the DOM structure."
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import { Grid } from '@dnb/eufemia'\n\nrender(\n  <Grid.Container>\n    <Grid.Item>content</Grid.Item>\n    <Grid.Item>content</Grid.Item>\n  </Grid.Container>,\n)\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
